import React from 'react';
import customHistory from 'customHistory';
import { BLOCKED_BONUS_MODAL_ID } from 'common/constants/profile.constants';
import { NewModal } from '../../index';
import Image from '../common.image.png';
import { S } from '../common.style';
import ModalStore from '../../../../../common/stores/modal.store';

export const BlockedBonusModalRockWest = () => {
  return (
    <NewModal ModalId={BLOCKED_BONUS_MODAL_ID}>
      <img src={Image} alt="KYC" width="235" height="218" />
      <S.Bold>Bonus is not available </S.Bold>
      <S.Dimmer>please contact technical support!</S.Dimmer>
      <S.Button
        onClick={() => {
          customHistory.go(-1);
          ModalStore.pop();
        }}
      >
        Go back
      </S.Button>
    </NewModal>
  );
};
